module.exports = __webpack_public_path__ + "static/media/home-slide1.670a4682.jpg";